import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-table-sort',
  templateUrl: './table-sort.component.html',
  styleUrls: ['./table-sort.component.scss']
})
export class TableSortComponent implements OnInit {

  constructor() { }

  @Input() public fieldName: string;
  @Input() public tablesort:any;
  @Input() tablesortEvent: EventEmitter<any>
  @Output() onSort = new EventEmitter<any>();
  

  ngOnInit(): void {    
    this.tablesortEvent.subscribe(newtablesort => {        
      this.tablesort = newtablesort;
     })
  }

  toggleSort(name: string, sort?: string) {    
    let querySort = '';
    if(!this.tablesort[name]){
      this.tablesort = {};
      this.tablesort[name] = 'ASC' ;
      querySort = name+'.ASC'
    }    
    

    if(this.tablesort[name] == 'DESC'){
      this.tablesort[name] = 'ASC';
      querySort = name+'.ASC'
    }else if(this.tablesort[name] == 'ASC'){
      this.tablesort[name] = 'DESC';
      querySort = name+'.DESC'
    }

    this.onSort.emit({'querySort':querySort,'tablesort':this.tablesort});
  }
}
